export default __webpack_public_path__ + "static/media/AKM_3.32d5917e.png";